import { TIME } from 'client/utils/time';
import { cookie } from 'client/utils/cookie/cookie';

export const ZIP_REGEX = /^\d{5}$/;
const COORDINATE_REGEX = /^[-+]?\d*\.?\d+$/;

export function isValidZip(zip) {
  return ZIP_REGEX.test(zip);
}

export function getValidZipStr(zipToTest, oldZip = '') {
  const result = isValidZip(zipToTest) ? zipToTest || '' : oldZip || '';
  return String(result);
}

export function isValidCoordinate(coordinate) {
  return COORDINATE_REGEX.test(coordinate);
}

const DMA_NUMBER_REGEX = /\d+/;

/**
 * Normalizes DMA value, e.g. d803 => 803
 *
 * @param {String} dma Unparsed dma value, e.g. d803
 * @return {String}    Parsed dma value, e.g. 803
 */
export function parseDma(dma) {
  if (!dma) return undefined;
  const matched = dma.match(DMA_NUMBER_REGEX);
  return matched && matched[0];
}

export function parseLocation(locationData, userSet = false, defaultLocation = {}, customLocation = {}) {
  // location data returned by zip api could be either array or a regular object
  let matchedLocation = Array.isArray(locationData) ? locationData[0] : locationData;
  let isUserSet = !!userSet;

  // if location is not defined or zip is invalid use default location and mark userSet as false
  if (!(matchedLocation && isValidZip(matchedLocation.zipCode))) {
    matchedLocation = defaultLocation;
    isUserSet = false;
  }

  const dma = parseDma(matchedLocation.dma);

  const location = {
    ...matchedLocation,
    dma,
    userSet: isUserSet,
    ...customLocation,
  };

  /*
   * The code block below is quite painful and doesn't seem like it should exist here.  It appears to have been added a long time ago
   * with PLAT-461 (81a06712).  At that time, no IP fields were set in visitor.js (previously middleware/location-context.js).
   *
   * Eventually however, we started setting ip fields directly in /middleware/location-context.js (ie. current visitor.js).
   * If you want to dig into the history of /middleware/location-context.js, you can fit it here:
   *
   * - https://gitlab.com/edmundscom/edmunds/node-site-venom/-/blame/d8f4c877f02/server/middleware/location-context.js
   * - https://gitlab.com/edmundscom/edmunds/node-site-venom/-/commits/d8f4c877f02/server/middleware/location-context.js
   *
   * Now, this block appears to be utilized as a fallback of some kind, but it's difficult to tell for which cases and why.
   * More digging is required, IMO.  If you know the answer, please update this comment :)
   */
  if (!isUserSet) {
    // we only need to use a fallback for these fields if they are not already present.
    // Most of the time they are already passed into parseLocation.
    location.ipZipCode = location.ipZipCode || matchedLocation.zipCode;
    location.ipDma = location.ipDma || dma;
    location.ipStateCode = location.ipStateCode || matchedLocation.stateCode;
  }
  return location;
}

export function setLocationCookie(location) {
  cookie.set('location', location, {
    domain: '.edmunds.com',
    httpOnly: false,
    secure: true,
    maxAge: TIME.MS.ONE_YEAR,
    path: '/',
  });
}
